import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { AdvanceLoadState, logisticsActionCreators, LogisticsActionKeys } from '..';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { advanceLoadState } from '../logisticsApi';

function* advanceLoadStateSaga(action: AdvanceLoadState) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(advanceLoadState, action.payload.loadNumber);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(
        logisticsActionCreators.setLoadPartial({
          loadNumber: action.payload.loadNumber,
          loadStateId: response.value.value.loadStateId
        })
      );
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchAdvanceLoadState() {
  yield takeEvery(LogisticsActionKeys.ADVANCE_LOAD_STATE, advanceLoadStateSaga);
}
